// extracted by mini-css-extract-plugin
export default {"MainContent":"ArtifactRegistryShow-module__MainContent--IPH2D","Sidebar":"ArtifactRegistryShow-module__Sidebar--plbsj"};